export default {
  mapBoxAccessToken: process.env.GATSBY_MAPBOX_ACCESS_TOKEN
};



// WEBPACK FOOTER //
// ./src/constants.js